import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const ProtectedAdminRoute = ({ children }) => {
  const token = localStorage.getItem("adminToken");
  const location = useLocation();

  // ✅ Agar login hai aur user login page khol raha hai → dashboard bhej do
  if (token && location.pathname === "/admin/login") {
    return <Navigate to="/admin/dashboard" replace />;
  }

  // ✅ Agar token nahi hai aur user kisi bhi admin page par hai → login bhej do
  if (!token && location.pathname.startsWith("/admin") && location.pathname !== "/admin/login") {
    return <Navigate to="/admin/login" replace />;
  }

  // ✅ Otherwise allow
  return children;
};

export default ProtectedAdminRoute;
